import { useState } from "react";
import { useAppSelector } from "store/hooks";
import activeBellFullPng from "../../../assets/images/icons/bell_active-full.png";
import inactiveBellFullPng from "../../../assets/images/icons/bell_inactive-full.png";
import activeBellEmptyPng from "../../../assets/images/icons/bell_active-empty.png";
import inactiveBellEmptyPng from "../../../assets/images/icons/bell_inactive-empty.png";

import { Popover } from "react-tiny-popover";
import { NotificationBellPopover } from "./NotificationBellPopover";
import { IsRunningOverwolf } from "utilityFunctions";

export type UserNotificationResponse = {
  id: string;
  labels: { en: string; fr: string };
  read: boolean;
};

export const NotificationBell = () => {
  const [showNotifications, setShowNotifications] = useState<boolean>(false);
  const userInfo = useAppSelector((state) => state.auth.userInfo);
  const notifications = userInfo?.notifications;
  const unreadNotifications = notifications?.filter(
    (notification: UserNotificationResponse) => !notification.read
  );
  const showInactiveBell =
    notifications?.length === 0 ||
    !notifications ||
    unreadNotifications?.length === 0;
  const isRunningOverwolf = IsRunningOverwolf();
  const [popupOpen, setOpen] = useState(false);

  const selectedSvgSource = () => {
    if (showInactiveBell && !popupOpen) {
      return inactiveBellEmptyPng;
    } else if (showInactiveBell && popupOpen) {
      return inactiveBellFullPng;
    } else if (!showInactiveBell && !popupOpen) {
      return activeBellEmptyPng;
    } else {
      return activeBellFullPng;
    }
  };

  return (
    <>
      <Popover
        containerClassName="z-50"
        positions={["bottom", "left"]}
        onClickOutside={() => {
          setShowNotifications(false);
          setOpen(false);
        }}
        content={<NotificationBellPopover notifications={notifications} />}
        isOpen={showNotifications}
      >
        {
          <button
            type="button"
            onClick={() => {
              const newState = !showNotifications;
              setShowNotifications(newState);
              setOpen(newState);
            }}
            className={`${
              isRunningOverwolf ? "" : "-mt-4 lg:-mt-2"
            } flex items-center justify-center hover:opacity-70 transition ease-in-out duration-200`}
          >
            <div>
              {unreadNotifications?.length > 0 && (
                <div
                  className={`font-bold absolute ${
                    isRunningOverwolf
                      ? "h-3 w-3 top-4 right-0"
                      : "h-5 w-5 top-10 sm:top-3 md:top-6 right-4 sm:right-0"
                  } bg-red-500 rounded-full text-white flex items-center justify-center font-mono text-xs`}
                >
                  {unreadNotifications?.length}
                </div>
              )}
              <img
                className={`${isRunningOverwolf ? "h-7" : "h-10"}`}
                src={selectedSvgSource()}
                alt="notifications"
              />
            </div>
          </button>
        }
      </Popover>
    </>
  );
};
